export default __webpack_public_path__ + "static/20-f47670130882217d5f8935abc32a1434.png";